module.exports = __webpack_public_path__ + "img/item2.a0c7f0d1.png";